import { createTransport } from "@/src/config/transportFactory.js";
import { transport as railsTransport } from "@/src/config/apiConfig.js";
import { crmTransport } from "@/src/config/crmTransport.js";

const { transport: approvalsTransport } = createTransport("approvals");

const CRM_OBJECT_SLUG = "approval_requests";

export default {
  async getApprovalSchema() {
    try {
      let res = await crmTransport.get(`/schema/objects/${CRM_OBJECT_SLUG}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting approval schema: ", error);
      throw error;
    }
  },

  async getApprovals(params = {}) {
    try {
      let res = await railsTransport.get(`/api/crm/v2/objects/${CRM_OBJECT_SLUG}`, { params });
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting approvals: ", error);
      throw error;
    }
  },

  async getApprovalByID(id, params = {}) {
    try {
      let res = await railsTransport.get(`/api/crm/v2/objects/${CRM_OBJECT_SLUG}/${id}`, { params });
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting approval by ID: ", error);
      throw error;
    }
  },

  async createApproval(payload) {
    try {
      let res = await railsTransport.post(`/api/crm/v2/objects/${CRM_OBJECT_SLUG}`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating approval: ", error);
      throw error;
    }
  },

  async updateApproval(id, payload) {
    try {
      let res = await railsTransport.patch(`/api/crm/v2/objects/${CRM_OBJECT_SLUG}/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating approval: ", error);
      throw error;
    }
  },

  async deleteApproval(id) {
    try {
      let res = await railsTransport.delete(`/api/crm/v2/objects/${CRM_OBJECT_SLUG}/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting approval: ", error);
      throw error;
    }
  },

  async approveApproval(id, payload = {}) {
    try {
      let res = await approvalsTransport.post(`/approvals/${id}/approve`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while approving approval: ", error);
      throw error;
    }
  },

  async rejectApproval(id, payload = {}) {
    try {
      let res = await approvalsTransport.post(`/approvals/${id}/reject`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while rejecting approval: ", error);
      throw error;
    }
  },
};
